export default __webpack_public_path__ + "static/media/16_photo.232ccba6.jpeg";